import styled from "styled-components";

export const ReplyListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
